"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChecklistFieldValue = void 0;
const custom_types_1 = require("./custom-types");
const dates_1 = require("./dates");
const objects_1 = require("./objects");
const primitives_1 = require("./primitives");
const arrays_1 = require("./arrays");
const isChecklistFieldValue = (fieldValue) => {
    if ((0, primitives_1.isNullValue)(fieldValue) || typeof fieldValue !== "object") {
        return false;
    }
    const { items, total_items, completed_items } = fieldValue;
    const normalizedItems = Array.isArray(items) ? items : [];
    const isItemsValid = (0, arrays_1.isArrayOfValidObjectsValue)(normalizedItems, {
        id: custom_types_1.isIDValue,
        content: objects_1.isObjectLikeValue,
        completed: primitives_1.isBooleanValue,
        completed_at: dates_1.isNullableDateAsStringValue,
        assignee: custom_types_1.isNullableIdValue,
        due_date: dates_1.isNullableDateAsStringValue,
    }, true);
    const isTotalItemsValid = (0, primitives_1.isNumberValue)(total_items);
    const isCompletedItemsValid = (0, primitives_1.isNumberValue)(completed_items);
    return isItemsValid && isTotalItemsValid && isCompletedItemsValid;
};
exports.isChecklistFieldValue = isChecklistFieldValue;
